import axios from '@/plugins/Axios'

function Requests () {
  async function placeOrder(link) {
    try {
      const { data } = await axios.put(link)
      return data
    } catch (error) {
      console.log(error)
    }
  }

  async function checkReferralCode(param) {
    try {
      const { data } = await axios.post('/check-referral-code', param)
      return data
    } catch (error) {
      console.log(error)
    }
  }

  return {
    placeOrder,
    checkReferralCode
  }
}

export default Requests()
